import * as React from 'react';
import { Button } from '@blueprintjs/core';
import { translateKey } from 'app/utils/forms';

const DEFAULT_VIEW_BUTTON_LABEL = translateKey('vleader.edit');

interface Props {
    label?: string;
    onPress: () => void;
};

interface State {}

export class EditButton extends React.Component<Props, State> {

    state: State = {

    }
    
    handlePress = () => {
        const {
            onPress
        } = this.props;

        if (onPress) {
            onPress();
        }
    }

	render() {
        const {
            label
        } = this.props;

        return <Button rightIcon="settings" text={label ? label : DEFAULT_VIEW_BUTTON_LABEL} onClick={this.handlePress}/>
	}
}
